import { api } from './http.api';

export const configBaseUrl = 'web/open/config/version';

export const getConfigRequest = async (configVersion: number): Promise<{ data: unknown }> =>
  await api.get(`/${configBaseUrl}/${configVersion}`);
